<form [formGroup]="passwordChangeForm" class="user-new-password" (ngSubmit)="passwordChangeForm.valid && onPasswordChange()">
  <!-- fields on the left -->
  <div class="qa-pw-fields">
    <div class="form-group" [ngClass]="{'hidden': oldPassword.disabled}">
      <label for="oldPassword">{{_(KEYS.CRUD.CURRENT_PASSWORD)}}</label>
      <input
        [type]="showPasswords ? 'text' : 'password'"
        class="form-control"
        id="oldPassword"
        placeholder="{{_(KEYS.CRUD.ENTER_CURRENT_PASSWORD)}}"
        formControlName="oldPassword"
        name="oldPassword"
        autocomplete="current-password"
        (keyup)="onResetOldPasswordCheckTimeout()">
      <div class="invalid-feedback display" *ngIf="oldPassword.errors?.oldPassword">{{_(KEYS.CRUD.INVALID_PASSWORD)}}</div>
    </div>

    <div class="form-group">
      <label for="newPassword">{{_(KEYS.CRUD.NEW_PASSWORD)}}</label>
      <div class="qa-pw-input">
        <input
          [type]="showPasswords ? 'text' : 'password'"
          class="form-control"
          id="newPassword"
          placeholder="{{_(KEYS.CRUD.ENTER_NEW_PASSWORD)}}"
          formControlName="newPassword"
          name="newPassword"
          autocomplete="new-password">
        <button type="button" class="qa-pw-eye" (click)="showPasswords = !showPasswords" [attr.aria-pressed]="showPasswords"
                [attr.title]="showPasswords ? _(KEYS.CRUD.HIDE_PASSWORDS) : _(KEYS.CRUD.SHOW_PASSWORDS)"
                [attr.aria-label]="showPasswords ? _(KEYS.CRUD.HIDE_PASSWORDS) : _(KEYS.CRUD.SHOW_PASSWORDS)">
          <i class="fa" [ngClass]="showPasswords ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <div class="form-group">
      <label for="newPasswordRepeat">{{_(KEYS.CRUD.REPEAT_NEW_PASSWORD)}}</label>
      <input
        [type]="showPasswords ? 'text' : 'password'"
        class="form-control"
        id="newPasswordRepeat"
        placeholder="{{_(KEYS.CRUD.ENTER_NEW_PASSWORD)}}"
        formControlName="newPasswordRepeat"
        name="newPasswordRepeat"
        autocomplete="new-password">
    </div>

    <button type="submit" class="btn btn-primary" [disabled]="!passwordChangeForm.valid">
      <i class="fa fa-save" aria-hidden="true"></i> {{_(KEYS.CRUD.CHANGE_PASSWORD)}}
    </button>
  </div>

  <!-- policy on the right, checked while typing -->
  <aside class="qa-pw-policy" aria-live="polite">
    <div class="qa-pw-policy-title"><i class="fa fa-shield" aria-hidden="true"></i> {{_(KEYS.CRUD.PASSWORD_POLICY)}}</div>
    <p *ngIf="passwordPolicy?.hint" class="qa-pw-policy-hint">{{_(passwordPolicy.hint)}}</p>
    <ul class="qa-pw-checks">
      <li [ngClass]="'qa-pw-' + policyState">
        <i class="fa" [ngClass]="stateIcon(policyState)" aria-hidden="true"></i> {{_(KEYS.CRUD.POLICY_MET)}}
      </li>
      <li [ngClass]="'qa-pw-' + matchState">
        <i class="fa" [ngClass]="stateIcon(matchState)" aria-hidden="true"></i> {{_(KEYS.CRUD.PASSWORDS_MATCH)}}
      </li>
    </ul>
  </aside>
</form>
